module.exports = __webpack_public_path__ + "img/118061597_3487214064678660_4759054660649536454_n.2ee963a6.jpg";